/**
 * Where the Add Existing Person sheet was opened from. The entry point drives the sheet subtitle and
 * the wording of the Previous Relationships confirmation.
 */
export const ADD_EXISTING_PERSON_ENTRY_POINTS = {
  /** "Add Group Members" on a person's Relationships card — the group already exists. */
  RELATIONSHIPS_CARD: 'relationshipsCard',
  /** "Add Person to New Group" on the names panel — there is no focus person yet. */
  NEW_GROUP: 'newGroup',
}

/** Steps the flow can be on. Each maps to one overlay. */
export const ADD_EXISTING_PERSON_STEPS = {
  SELECT: 'select',
  PREVIOUS_RELATIONSHIPS: 'previousRelationships',
  PRIMARY_PERSON: 'primaryPerson',
}

/** Form-value prefix for the sheet's name checkboxes. */
export const SELECTION_PREFIX = 'selectedPersons'

/** Form id for the Add Existing Person selection form. */
export const FORM_ID = 'add-existing-person-form'
